import React, {useContext} from 'react'
import {Navigate} from 'react-router'
import Container from 'react-bootstrap/Container'
import Row from 'react-bootstrap/Row'
import Col from 'react-bootstrap/Col'

import AuthContext from '../../../contexts/AuthContext'
import LoginTabs from './LoginTabs.tsx'
import Logo from '../../ui/logos/Logo'
import {useFlowerFeast} from '../../../hooks/useFlowerFeast'

export type ImpersonateProps = {
  impersonate: boolean
}

const Login = (props: ImpersonateProps) => {
    const {isAuthenticated} = useContext<{ isAuthenticated: boolean }>(AuthContext)
    const {hasFlowerFeast} = useFlowerFeast()

    return isAuthenticated ? (
        <Navigate
            to={hasFlowerFeast > 0 ? '/executions' : '/tableau-de-bord'}
        />
    ) : (
        <div className="login bg-white-dark">
            <Container fluid>
                <Row style={{height: '100vh'}} className={'align-items-center'}>
                    <Col xs={12} md={5} className={'mx-auto'}>
                        <Row className={'mb-2'}>
                            <Col className={'text-center'}>
                                <Logo />
                            </Col>
                        </Row>
                        <Row>
                            <Col>
                                <LoginTabs  {...props} />
                            </Col>
                        </Row>
                    </Col>
                </Row>
            </Container>
        </div>
    )
}

export default Login
